import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Card, CardContent, Typography, TextField, Button, Alert, CircularProgress } from '@mui/material';
import { usePostDataFetch } from '../utils/useDataFetch';

const ApproveTrainerWithCode = () => {
    const { userId } = useParams();
    const navigate = useNavigate();
    const [code, setCode] = useState('');
    
    const { data, error, isLoading, postData } = usePostDataFetch();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!code) return;
        
        await postData({
            url: '/auth/approve-trainer-code',
            aBody: { userId, code },
            skipAuth: true
        });
    };

    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2, bgcolor: 'background.default' }}>
            <Card sx={{ maxWidth: 400, width: '100%', boxShadow: 4, borderRadius: "12px" }}>
                <CardContent sx={{ p: 4, textAlign: 'center' }}>
                    <Typography variant="h5" fontWeight="bold" gutterBottom color="primary">
                        Trainer freischalten
                    </Typography>
                    
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
                        Bitte gib den 8-stelligen Freischaltcode ein, den du per E-Mail erhalten hast.
                    </Typography>

                    {data?.success ? (
                        <Box>
                            <Alert severity="success" sx={{ mb: 3 }}>
                                {data.message || 'Der Trainer wurde erfolgreich freigeschaltet!'}
                            </Alert>
                            <Button 
                                variant="contained" 
                                fullWidth 
                                onClick={() => navigate('/auth')}
                            >
                                Zum Login
                            </Button>
                        </Box>
                    ) : (
                        <form onSubmit={handleSubmit}>
                            <TextField
                                label="Freischaltcode"
                                variant="outlined"
                                fullWidth
                                required
                                value={code}
                                onChange={(e) => setCode(e.target.value.toUpperCase())}
                                sx={{ mb: 3 }}
                                inputProps={{ maxLength: 8, style: { textAlign: 'center', letterSpacing: 4, fontSize: '1.2rem', fontWeight: 'bold' } }}
                                placeholder="XXXXXXXX"
                            />
                            
                            {error && (
                                <Alert severity="error" sx={{ mb: 3 }}>
                                    {typeof error === 'object' ? error.message : error}
                                </Alert>
                            )}

                            <Button 
                                type="submit" 
                                variant="contained" 
                                color="primary" 
                                size="large" 
                                fullWidth 
                                disabled={isLoading || code.length < 4}
                                sx={{ py: 1.5, fontWeight: 'bold' }}
                            >
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Trainer freischalten'}
                            </Button>
                        </form>
                    )}
                </CardContent>
            </Card>
        </Box>
    );
};

export default ApproveTrainerWithCode;
